function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var AdminMain = require('./lib/ui/main');
var AdminHome = require('./index');
var AdminServerConnection = require('./lib/server-connection');
var _require = require('./lib/module-metadata'),
  readModuleMetadata = _require.readModuleMetadata,
  serveModuleImage = _require.serveModuleImage;
var Admin = /*#__PURE__*/function (_ModTemplate) {
  function Admin(app) {
    var _this;
    _classCallCheck(this, Admin);
    _this = _callSuper(this, Admin, [app]);
    _this.name = 'Admin';
    _this.slug = 'admin';
    _this.description = 'Admin module for Saito application management';
    _this.categories = 'Admin utilities';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.server_publickey = '';
    _this.server_info = null;
    _this.server_connection = new AdminServerConnection(_this);
    return _this;
  }
  _inherits(Admin, _ModTemplate);
  return _createClass(Admin, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Admin, "initialize", this, 3)([app]);
            case 1:
              this.main = new AdminMain(app, this);
              if (app.BROWSER && this.browser_active) {
                this.server_publickey = server_publickey;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.server_publickey = server_publickey;
              this.main.render();
              this.server_connection.start();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "onConnectionUnstable",
    value: function onConnectionUnstable(app, publicKey) {
      if (this.browser_active) this.server_connection.onDisconnect(publicKey);
    }
  }, {
    key: "onPeerHandshakeComplete",
    value: function () {
      var _onPeerHandshakeComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, peer) {
        var _this2 = this;
        var tx;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.browser_active) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (this.server_connection.onHandshake(peer)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              if (!need_to_set_key) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _context3.n = 4;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(server_publickey);
            case 4:
              tx = _context3.v;
              tx.msg = {
                module: 'Admin',
                request: 'validate-admin-key',
                key: this.publicKey
              };
              _context3.n = 5;
              return tx.sign();
            case 5:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                // Transport failures arrive as plain { err } objects, not transactions.
                var res = typeof res_tx.returnMessage === 'function' ? res_tx.returnMessage() : res_tx;
                if (res !== null && res !== void 0 && res.err) {
                  alert(res.err);
                } else {
                  _this2.server_info = res;
                  _this2.main.render();
                }
              }, peer.publicKey);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onPeerHandshakeComplete(_x2, _x3) {
        return _onPeerHandshakeComplete.apply(this, arguments);
      }
      return onPeerHandshakeComplete;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          accepted_requests,
          signer,
          admins,
          validated,
          result,
          _txmsg$data,
          db,
          _result,
          _txmsg$data2,
          _txmsg$data3,
          _db,
          query,
          _result2,
          peers,
          Saito,
          transport,
          snapshot,
          faucet,
          config,
          _config,
          err,
          previous,
          _peers,
          _err,
          connecting,
          _err2,
          _args4 = arguments,
          _t,
          _t2,
          _t3,
          _t4,
          _t5,
          _t6,
          _t7,
          _t8,
          _t9,
          _t0,
          _t1,
          _t10,
          _t11,
          _t12,
          _t13,
          _t14,
          _t15,
          _t16;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              tx = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
              peer = _args4.length > 2 ? _args4[2] : undefined;
              mycallback = _args4.length > 3 ? _args4[3] : undefined;
              if (!this.app.BROWSER) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, 0);
            case 1:
              if (!(!tx || !tx.isTo(this.publicKey))) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, 0);
            case 2:
              txmsg = tx.returnMessage();
              if (txmsg !== null && txmsg !== void 0 && txmsg.request) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, _superPropGet(Admin, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
            case 3:
              accepted_requests = ['list-databases', 'list-database-tables', 'list-peers', 'run-sql-query', 'set-admin-key', 'list-admins', 'add-admin', 'remove-admin', 'promote-admin', 'validate-admin-key', 'update-options', 'update-modules-config', 'update-peers', 'list-blockchain-state', 'list-mempool', 'list-faucet', 'get-admin-config', 'update-admin-config'];
              if (accepted_requests.includes(txmsg.request)) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2, _superPropGet(Admin, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
            case 4:
              signer = this.adminRequestSigner(tx);
              admins = this.app.options.admin || [];
              validated = signer && (admins.length ? admins.includes(signer) : txmsg.request === 'set-admin-key');
              if (validated) {
                _context4.n = 5;
                break;
              }
              console.error('Unauthorized access!');
              if (mycallback) {
                mycallback({
                  err: 'Unauthorized access'
                });
              }
              return _context4.a(2, 0);
            case 5:
              if (!['set-admin-key', 'list-admins', 'add-admin', 'remove-admin', 'promote-admin'].includes(txmsg.request)) {
                _context4.n = 6;
                break;
              }
              try {
                result = this.manageAdministrators(txmsg.request, txmsg.key, signer);
                if (mycallback) mycallback({
                  result: result
                });
              } catch (err) {
                if (mycallback) mycallback({
                  err: err.message || String(err)
                });
              }
              return _context4.a(2, 1);
            case 6:
              if (!(txmsg.request == 'list-databases')) {
                _context4.n = 7;
                break;
              }
              try {
                if (mycallback) mycallback({
                  result: this.listSqliteDatabases()
                });
              } catch (err) {
                if (mycallback) mycallback({
                  err: this.sqliteError('', err)
                });
              }
              return _context4.a(2, 1);
            case 7:
              if (!(txmsg.request == 'list-database-tables')) {
                _context4.n = 12;
                break;
              }
              db = (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.db;
              if (db) {
                _context4.n = 8;
                break;
              }
              if (mycallback) mycallback({
                err: 'No database specified'
              });
              return _context4.a(2, 1);
            case 8:
              _context4.p = 8;
              _context4.n = 9;
              return this.executeAdminSql(db, "SELECT name FROM sqlite_master WHERE type='table' ORDER BY name");
            case 9:
              _result = _context4.v;
              if (mycallback) mycallback({
                result: _result.rows || []
              });
              _context4.n = 11;
              break;
            case 10:
              _context4.p = 10;
              _t = _context4.v;
              if (mycallback) mycallback({
                err: this.sqliteError(db, _t)
              });
            case 11:
              return _context4.a(2, 1);
            case 12:
              if (!(txmsg.request == 'run-sql-query')) {
                _context4.n = 18;
                break;
              }
              _db = (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.db;
              query = (_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.query;
              if (_db) {
                _context4.n = 13;
                break;
              }
              if (mycallback) mycallback({
                err: 'No database specified'
              });
              return _context4.a(2, 1);
            case 13:
              if (!(!query || !String(query).trim())) {
                _context4.n = 14;
                break;
              }
              if (mycallback) mycallback({
                err: 'No SQL provided'
              });
              return _context4.a(2, 1);
            case 14:
              _context4.p = 14;
              _context4.n = 15;
              return this.executeAdminSql(_db, query);
            case 15:
              _result2 = _context4.v;
              if (mycallback) mycallback({
                result: _result2
              });
              _context4.n = 17;
              break;
            case 16:
              _context4.p = 16;
              _t2 = _context4.v;
              if (mycallback) mycallback({
                err: this.sqliteError(_db, _t2)
              });
            case 17:
              return _context4.a(2, 1);
            case 18:
              if (!(txmsg.request === 'list-peers')) {
                _context4.n = 23;
                break;
              }
              _context4.p = 19;
              _context4.n = 20;
              return this.app.core.network.getPeers();
            case 20:
              peers = _context4.v;
              Saito = require('saito-js/saito')["default"];
              transport = Saito.getInstance();
              snapshot = (peers || []).map(function (p) {
                var _transport$getSocketB;
                var host = typeof (p === null || p === void 0 ? void 0 : p.host) === 'string' ? p.host : '';
                var port = Number(p === null || p === void 0 ? void 0 : p.port) || 0;
                return {
                  publicKey: (p === null || p === void 0 ? void 0 : p.publicKey) || '',
                  // Transport address may be a reverse proxy; do not trust forwarded headers.
                  ip: ((_transport$getSocketB = transport.getSocketByPeerId(p.id)) === null || _transport$getSocketB === void 0 || (_transport$getSocketB = _transport$getSocketB._socket) === null || _transport$getSocketB === void 0 ? void 0 : _transport$getSocketB.remoteAddress) || '',
                  host: host,
                  // Keep empty ports empty so hostless browser peers are not collapsed as "|0".
                  port: port > 0 ? port : '',
                  protocol: typeof (p === null || p === void 0 ? void 0 : p.protocol) === 'string' ? p.protocol : '',
                  synctype: typeof (p === null || p === void 0 ? void 0 : p.synctype) === 'string' ? p.synctype : '',
                  status: typeof (p === null || p === void 0 ? void 0 : p.status) === 'string' ? p.status : '',
                  id: (p === null || p === void 0 ? void 0 : p.id) != null ? String(p.id) : ''
                };
              });
              if (mycallback) mycallback({
                result: snapshot
              });
              _context4.n = 22;
              break;
            case 21:
              _context4.p = 21;
              _t3 = _context4.v;
              if (mycallback) mycallback({
                err: _t3.message
              });
            case 22:
              return _context4.a(2, 1);
            case 23:
              if (!(txmsg.request == 'list-blockchain-state')) {
                _context4.n = 29;
                break;
              }
              _context4.p = 24;
              if (!mycallback) {
                _context4.n = 26;
                break;
              }
              _t4 = mycallback;
              _context4.n = 25;
              return this.snapshotBlockchain();
            case 25:
              _t5 = _context4.v;
              _t4({
                result: _t5
              });
            case 26:
              _context4.n = 28;
              break;
            case 27:
              _context4.p = 27;
              _t6 = _context4.v;
              if (mycallback) mycallback({
                err: _t6.message || String(_t6)
              });
            case 28:
              return _context4.a(2, 1);
            case 29:
              if (!(txmsg.request == 'list-mempool')) {
                _context4.n = 35;
                break;
              }
              _context4.p = 30;
              if (!mycallback) {
                _context4.n = 32;
                break;
              }
              _t7 = mycallback;
              _context4.n = 31;
              return this.snapshotMempool();
            case 31:
              _t8 = _context4.v;
              _t7({
                result: _t8
              });
            case 32:
              _context4.n = 34;
              break;
            case 33:
              _context4.p = 33;
              _t9 = _context4.v;
              if (mycallback) mycallback({
                err: _t9.message || String(_t9)
              });
            case 34:
              return _context4.a(2, 1);
            case 35:
              if (!(txmsg.request == 'list-faucet')) {
                _context4.n = 42;
                break;
              }
              _context4.p = 36;
              faucet = this.app.modules.returnModule('Faucet');
              if (faucet) {
                _context4.n = 37;
                break;
              }
              if (mycallback) mycallback({
                err: 'Faucet is not installed on this server.'
              });
              _context4.n = 39;
              break;
            case 37:
              if (!mycallback) {
                _context4.n = 39;
                break;
              }
              _t0 = mycallback;
              _context4.n = 38;
              return faucet.adminSnapshot(txmsg.filter || 'recent');
            case 38:
              _t1 = _context4.v;
              _t0({
                result: _t1
              });
            case 39:
              _context4.n = 41;
              break;
            case 40:
              _context4.p = 40;
              _t10 = _context4.v;
              if (mycallback) mycallback({
                err: _t10.message || String(_t10)
              });
            case 41:
              return _context4.a(2, 1);
            case 42:
              if (!(txmsg.request === 'get-admin-config')) {
                _context4.n = 49;
                break;
              }
              _context4.p = 43;
              config = this.returnAdminConfig(txmsg.module_id);
              if (!(!config || typeof config.getConfig !== 'function')) {
                _context4.n = 44;
                break;
              }
              throw new Error("No admin configuration is available for \"".concat(txmsg.module_id || '', "\"."));
            case 44:
              if (!mycallback) {
                _context4.n = 46;
                break;
              }
              _t11 = mycallback;
              _context4.n = 45;
              return config.getConfig(txmsg);
            case 45:
              _t12 = _context4.v;
              _t11({
                result: _t12
              });
            case 46:
              _context4.n = 48;
              break;
            case 47:
              _context4.p = 47;
              _t13 = _context4.v;
              if (mycallback) mycallback({
                err: _t13.message || String(_t13)
              });
            case 48:
              return _context4.a(2, 1);
            case 49:
              if (!(txmsg.request === 'update-admin-config')) {
                _context4.n = 56;
                break;
              }
              _context4.p = 50;
              _config = this.returnAdminConfig(txmsg.module_id);
              if (!(!_config || typeof _config.updateConfig !== 'function')) {
                _context4.n = 51;
                break;
              }
              throw new Error("No editable admin configuration is available for \"".concat(txmsg.module_id || '', "\"."));
            case 51:
              if (!mycallback) {
                _context4.n = 53;
                break;
              }
              _t14 = mycallback;
              _context4.n = 52;
              return _config.updateConfig(txmsg.data || {});
            case 52:
              _t15 = _context4.v;
              _t14({
                result: _t15
              });
            case 53:
              _context4.n = 55;
              break;
            case 54:
              _context4.p = 54;
              _t16 = _context4.v;
              if (mycallback) mycallback({
                err: _t16.message || String(_t16)
              });
            case 55:
              return _context4.a(2, 1);
            case 56:
              if (!(txmsg.request == 'validate-admin-key')) {
                _context4.n = 57;
                break;
              }
              if (mycallback) mycallback(this.getOptions());
              return _context4.a(2, 1);
            case 57:
              if (!(txmsg.request == 'update-modules-config')) {
                _context4.n = 58;
                break;
              }
              err = this.writeModuleConfig(txmsg.config);
              if (mycallback) {
                mycallback(err ? {
                  err: err
                } : {
                  result: 1
                });
              }
              return _context4.a(2, 1);
            case 58:
              if (!(txmsg.request == 'update-peers')) {
                _context4.n = 59;
                break;
              }
              previous = Array.isArray(this.app.options.peers) ? this.app.options.peers.slice() : [];
              _peers = this.normalizePeerList(txmsg.peers);
              _err = this.updateOptions({
                peers: _peers
              });
              connecting = false;
              if (!_err) {
                connecting = this.connectNewPeers(previous, _peers);
              }
              if (mycallback) {
                mycallback(_err ? {
                  err: _err
                } : {
                  result: 1,
                  connecting: connecting
                });
              }
              return _context4.a(2, 1);
            case 59:
              if (!(txmsg.request == 'update-options')) {
                _context4.n = 60;
                break;
              }
              _err2 = this.updateOptions(txmsg.data);
              if (mycallback) {
                mycallback(_err2 ? {
                  err: _err2
                } : {
                  result: 1
                });
              }
              return _context4.a(2, 1);
            case 60:
              return _context4.a(2, _superPropGet(Admin, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee4, this, [[50, 54], [43, 47], [36, 40], [30, 33], [24, 27], [19, 21], [14, 16], [8, 10]]);
      }));
      function handlePeerTransaction(_x4) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "adminRequestSigner",
    value: function adminRequestSigner(tx) {
      try {
        var _tx$from;
        var signer = (_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey;
        if (!signer || !/^[a-fA-F0-9]{128}$/.test(tx.signature || '')) return null;
        tx.generateHashForSignature();
        // verifySignature hashes its input; the transaction already supplies a digest.
        var valid = require('secp256k1').verify(Buffer.from(tx.getHashForSignature()), Buffer.from(tx.signature, 'hex'), Buffer.from(this.app.crypto.fromBase58(signer), 'hex'));
        return valid ? signer : null;
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "administratorState",
    value: function administratorState(signer) {
      var admins = _toConsumableArray(this.app.options.admin || []);
      var is_admin = admins.includes(signer);
      return {
        admins: admins,
        permissions: {
          is_admin: is_admin,
          is_primary: is_admin && admins[0] === signer,
          can_add: is_admin,
          can_remove: is_admin,
          can_promote: is_admin && admins[0] === signer
        }
      };
    }
  }, {
    key: "manageAdministrators",
    value: function manageAdministrators(request, key, signer) {
      // Validation, atomic save, and activation are synchronous: requests cannot
      // interleave or apply permissions captured before a different admin's change.
      var admins = _toConsumableArray(this.app.options.admin || []);
      if (request === 'set-admin-key') {
        if (admins.length) throw new Error('The initial administrator is already configured.');
      } else if (!admins.includes(signer)) {
        throw new Error('Unauthorized access');
      }
      if (request === 'list-admins') return this.administratorState(signer);
      key = typeof key === 'string' ? key.trim() : '';
      if (!this.app.crypto.isPublicKey(key)) throw new Error('Not a valid Saito public key.');
      if (request === 'set-admin-key' || request === 'add-admin') {
        if (admins.includes(key)) throw new Error('That administrator is already listed.');
        admins.push(key);
      } else {
        var index = admins.indexOf(key);
        if (index < 0) throw new Error('That administrator is not listed.');
        if (request === 'remove-admin') {
          if (index === 0) throw new Error('The primary administrator cannot be removed. Transfer primary status first.');
          admins.splice(index, 1);
        } else if (request === 'promote-admin') {
          if (admins[0] !== signer) throw new Error('Only the primary administrator can transfer primary status.');
          if (index === 0) throw new Error('That administrator is already primary.');
          admins.splice(index, 1);
          admins.unshift(key);
        } else {
          throw new Error('Unknown administrator operation.');
        }
      }
      this.saveAdministrators(admins);
      return this.administratorState(signer);
    }
  }, {
    key: "saveAdministrators",
    value: function saveAdministrators(admins) {
      var fs = this.app.storage.returnFileSystem();
      var path = this.app.storage.returnPath();
      if (!fs || !path) throw new Error('Filesystem is not available on this server.');
      var filename = path.join(this.app.storage.config_dir || path.resolve(__dirname, '../../config'), 'options');
      var temporary = "".concat(filename, ".admin-").concat(require('crypto').randomBytes(12).toString('hex'), ".tmp");
      var json = require('json-bigint');
      var fd;
      try {
        fs.accessSync(filename, fs.constants.W_OK);
        var options = json.parse(fs.readFileSync(filename, 'utf8'));
        options.admin = admins;
        fd = fs.openSync(temporary, 'wx', fs.statSync(filename).mode & 511);
        fs.writeFileSync(fd, json.stringify(options, null, 2));
        fs.fsyncSync(fd);
        fs.closeSync(fd);
        fd = undefined;
        fs.renameSync(temporary, filename);
      } catch (err) {
        throw new Error(this.returnWriteError(filename, err));
      } finally {
        if (fd !== undefined) {
          try {
            fs.closeSync(fd);
          } catch (err) {}
        }
        try {
          fs.unlinkSync(temporary);
        } catch (err) {}
      }
      this.app.options.admin = admins;
    }

    /**
     * Modules expose server-owned settings through respondTo('admin-config').
     * The returned functions stay in-process; only their sanitized results are
     * sent over Admin's authenticated request channel.
     */
  }, {
    key: "returnAdminConfig",
    value: function returnAdminConfig() {
      var module_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var id = String(module_id || '').trim().toLowerCase();
      if (!id) {
        return null;
      }
      var modules = this.app.modules.returnModulesRespondingTo('admin-config') || [];
      var _iterator = _createForOfIteratorHelper(modules),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mod = _step.value;
          var config = mod.respondTo('admin-config');
          if (String((config === null || config === void 0 ? void 0 : config.id) || '').toLowerCase() === id) {
            return config;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var path = this.app.storage.returnPath();
      var fs = this.app.storage.returnFileSystem();
      var node_info = {};
      if (fs && path) {
        var config_dir = path.normalize("".concat(__dirname, "/../../config"));
        var modules_dir = path.normalize("".concat(__dirname, "/../../mods"));
        node_info.available_modules = this.listAvailableModules(fs, path, modules_dir);
        node_info.module_metadata = Object.fromEntries(node_info.available_modules.map(function (name) {
          return [name, readModuleMetadata(fs, path, modules_dir, name)];
        }));
        var modules_config = path.normalize("".concat(config_dir, "/modules.config.js"));
        this.module_config = {
          core: [],
          lite: []
        };
        if (fs.existsSync(modules_config)) {
          try {
            this.module_config = this.readModuleConfig(fs, modules_config);
          } catch (err) {
            console.error(err);
          }
        }
      }
      node_info.module_config = this.module_config || {
        core: [],
        lite: []
      };
      node_info.options = this.app.options;
      node_info.databases = [];
      var _iterator2 = _createForOfIteratorHelper(this.app.modules.mods || []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var m = _step2.value;
          if (m.db_tables && m.db_tables.length > 0) {
            node_info.databases.push({
              module: m.name,
              dbname: m.dbname ? m.dbname : m.returnSlug(),
              tables: m.db_tables
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return node_info;
    }
  }, {
    key: "listAvailableModules",
    value: function listAvailableModules(fs, path, modules_dir) {
      if (!fs.existsSync(modules_dir)) {
        return [];
      }
      var names = [];
      var _iterator3 = _createForOfIteratorHelper(fs.readdirSync(modules_dir)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var name = _step3.value;
          if (!name || name.startsWith('.')) {
            continue;
          }
          var dir = path.join(modules_dir, name);
          var entry = path.join(dir, "".concat(name, ".js"));
          try {
            if (fs.statSync(dir).isDirectory() && fs.existsSync(entry)) {
              names.push(name);
            }
          } catch (err) {
            continue;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      names.sort();
      return names;
    }
  }, {
    key: "readModuleConfig",
    value: function readModuleConfig(fs, filename) {
      var src = fs.readFileSync(filename, {
        encoding: 'UTF-8'
      });
      var core = [];
      var lite = [];
      var section = '';
      var _iterator4 = _createForOfIteratorHelper(src.split('\n')),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var line = _step4.value;
          var trimmed = line.replace(/^\s*\/\/.*$/, '').trim();
          if (/^core\s*:/.test(trimmed)) {
            section = 'core';
          }
          if (/^lite\s*:/.test(trimmed)) {
            section = 'lite';
          }
          if (section !== 'core' && section !== 'lite') {
            continue;
          }
          var _iterator5 = _createForOfIteratorHelper(trimmed.matchAll(/['"]([^'"]+)['"]/g)),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var match = _step5.value;
              if (section === 'core') {
                core.push(match[1]);
              } else {
                lite.push(match[1]);
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return {
        core: core,
        lite: lite
      };
    }
  }, {
    key: "writeModuleConfig",
    value: function writeModuleConfig(config_str) {
      var path = this.app.storage.returnPath();
      var fs = this.app.storage.returnFileSystem();
      if (!fs || !path) {
        return 'Filesystem is not available on this server.';
      }
      var filename = path.normalize("".concat(__dirname, "/../../config/modules.config.js"));
      var core = [];
      var lite = [];
      try {
        var parsedConfig = JSON.parse(config_str);
        core = Array.isArray(parsedConfig.core) ? parsedConfig.core : [];
        lite = Array.isArray(parsedConfig.lite) ? parsedConfig.lite : [];
      } catch (err) {
        return 'Module configuration was not valid JSON.';
      }
      if (!core.includes('admin/admin.js')) {
        core.unshift('admin/admin.js');
      }
      var formatList = function formatList(arr) {
        return arr.filter(function (item) {
          return typeof item === 'string' && item.includes('/');
        }).map(function (item) {
          return "    '".concat(item, "',");
        }).join('\n');
      };
      var output = "export default {\n  core: [\n".concat(formatList(core), "\n  ],\n  lite: [\n").concat(formatList(lite), "\n  ]\n};\n");
      try {
        fs.writeFileSync(filename, output);
      } catch (err) {
        return this.returnWriteError(filename, err);
      }
      return null;
    }
  }, {
    key: "peerKey",
    value: function peerKey(peer) {
      return "".concat(String((peer === null || peer === void 0 ? void 0 : peer.host) || '').toLowerCase(), "|").concat(String((peer === null || peer === void 0 ? void 0 : peer.port) || ''));
    }
  }, {
    key: "normalizePeerList",
    value: function normalizePeerList(list) {
      var peers = [];
      var seen = new Set();
      var _iterator6 = _createForOfIteratorHelper(Array.isArray(list) ? list : []),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var item = _step6.value;
          var host = String((item === null || item === void 0 ? void 0 : item.host) || '').trim();
          var protocol = String((item === null || item === void 0 ? void 0 : item.protocol) || '').trim();
          var port = Number(item === null || item === void 0 ? void 0 : item.port);
          if (!host || !port || protocol !== 'http' && protocol !== 'https') {
            continue;
          }
          var peer = {
            host: host,
            port: port,
            protocol: protocol,
            synctype: (item === null || item === void 0 ? void 0 : item.synctype) === 'lite' ? 'lite' : 'full'
          };
          var key = this.peerKey(peer);
          if (seen.has(key)) {
            continue;
          }
          seen.add(key);
          peers.push(peer);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return peers;
    }
  }, {
    key: "connectNewPeers",
    value: function connectNewPeers(previous, next) {
      var _this3 = this;
      var connecting = false;
      var had = new Set((previous || []).map(function (p) {
        return _this3.peerKey(p);
      }));
      var _iterator7 = _createForOfIteratorHelper(next || []),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var peer = _step7.value;
          if (had.has(this.peerKey(peer))) {
            continue;
          }
          if (this.connectPeer(peer)) {
            connecting = true;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return connecting;
    }
  }, {
    key: "connectPeer",
    value: function connectPeer(peer) {
      var ws_protocol = peer.protocol === 'https' ? 'wss' : 'ws';
      var url = "".concat(ws_protocol, "://").concat(peer.host, ":").concat(peer.port, "/wsopen");
      try {
        var _globalThis$shared_me;
        if ((_globalThis$shared_me = globalThis.shared_methods) !== null && _globalThis$shared_me !== void 0 && _globalThis$shared_me.connect_to_peer) {
          globalThis.shared_methods.connect_to_peer(url);
          return true;
        }
      } catch (err) {
        console.error(err);
      }
      return false;
    }
  }, {
    key: "listSqliteDatabases",
    value: function listSqliteDatabases() {
      var fs = this.app.storage.returnFileSystem();
      var path = this.app.storage.returnPath();
      var data_dir = this.app.storage.data_dir;
      if (!fs || !path || !data_dir) {
        return [];
      }
      if (!fs.existsSync(data_dir)) {
        return [];
      }
      var names = [];
      var _iterator8 = _createForOfIteratorHelper(fs.readdirSync(data_dir)),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var file = _step8.value;
          if (!file.endsWith('.sq3')) {
            continue;
          }
          var full = path.join(data_dir, file);
          try {
            if (fs.statSync(full).isFile()) {
              names.push(file.slice(0, -4));
            }
          } catch (err) {
            continue;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      names.sort();
      return names;
    }
  }, {
    key: "sqliteFile",
    value: function sqliteFile(dbname) {
      var path = this.app.storage.returnPath();
      var data_dir = this.app.storage.data_dir || '';
      if (!path) {
        return "".concat(dbname, ".sq3");
      }
      return path.join(data_dir, "".concat(dbname, ".sq3"));
    }
  }, {
    key: "openSqlite",
    value: function () {
      var _openSqlite = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dbname) {
        var db;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (this.listSqliteDatabases().includes(dbname)) {
                _context5.n = 1;
                break;
              }
              throw new Error("Database \"".concat(dbname, "\" was not found in ").concat(this.app.storage.data_dir || 'the data directory', "."));
            case 1:
              _context5.n = 2;
              return this.app.storage.returnDatabaseByName(dbname);
            case 2:
              db = _context5.v;
              if (db) {
                _context5.n = 3;
                break;
              }
              throw new Error("Could not open ".concat(this.sqliteFile(dbname), "."));
            case 3:
              return _context5.a(2, db);
          }
        }, _callee5, this);
      }));
      function openSqlite(_x5) {
        return _openSqlite.apply(this, arguments);
      }
      return openSqlite;
    }()
  }, {
    key: "executeAdminSql",
    value: function () {
      var _executeAdminSql = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dbname, sql) {
        var db, rows, msg, res, _t17;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.n = 1;
              return this.openSqlite(dbname);
            case 1:
              db = _context6.v;
              _context6.p = 2;
              _context6.n = 3;
              return db.all(sql);
            case 3:
              rows = _context6.v;
              return _context6.a(2, {
                rows: rows || []
              });
            case 4:
              _context6.p = 4;
              _t17 = _context6.v;
              msg = String((_t17 === null || _t17 === void 0 ? void 0 : _t17.message) || _t17);
              if (/does not return data|Use run\(\)|not a SELECT/i.test(msg)) {
                _context6.n = 5;
                break;
              }
              throw _t17;
            case 5:
              _context6.n = 6;
              return db.run(sql);
            case 6:
              res = _context6.v;
              return _context6.a(2, {
                changes: typeof (res === null || res === void 0 ? void 0 : res.changes) === 'number' ? res.changes : 0,
                lastID: res === null || res === void 0 ? void 0 : res.lastID
              });
          }
        }, _callee6, this, [[2, 4]]);
      }));
      function executeAdminSql(_x6, _x7) {
        return _executeAdminSql.apply(this, arguments);
      }
      return executeAdminSql;
    }()
  }, {
    key: "sqliteError",
    value: function sqliteError(dbname, err) {
      var filename = dbname ? this.sqliteFile(dbname) : this.app.storage.data_dir || 'the data directory';
      if ((err === null || err === void 0 ? void 0 : err.code) === 'EACCES' || (err === null || err === void 0 ? void 0 : err.code) === 'EPERM' || (err === null || err === void 0 ? void 0 : err.code) === 'SQLITE_READONLY') {
        return "We couldn't update ".concat(filename, " because this file is not writable by the Saito server. The user account that runs Saito needs write permission for that file. Give that account write access, then try again.");
      }
      if ((err === null || err === void 0 ? void 0 : err.code) === 'SQLITE_CANTOPEN' || (err === null || err === void 0 ? void 0 : err.code) === 'ENOENT') {
        return "We couldn't open ".concat(filename, ": ").concat(err.message || err);
      }
      if (dbname) {
        return "Database \"".concat(dbname, "\": ").concat((err === null || err === void 0 ? void 0 : err.message) || err);
      }
      return (err === null || err === void 0 ? void 0 : err.message) || String(err);
    }
  }, {
    key: "snapshotMempool",
    value: function () {
      var _snapshotMempool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var Saito, txs, limit, types, text, keys, sorted, _t18;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              Saito = require('saito-js/saito')["default"];
              _context7.n = 1;
              return Saito.getInstance().getMempoolTxs();
            case 1:
              _t18 = _context7.v;
              if (_t18) {
                _context7.n = 2;
                break;
              }
              _t18 = [];
            case 2:
              txs = _t18;
              limit = 200;
              types = ['Normal', 'Fee', 'Golden Ticket', 'ATR', 'VIP', 'SPV', 'Issuance', 'Block Stake', 'Bound'];
              text = function text(value) {
                if (value === null || value === undefined || value === '') {
                  return '';
                }
                if (typeof value === 'bigint') {
                  return value.toString();
                }
                return String(value);
              };
              keys = function keys(slips) {
                var out = [];
                var _iterator9 = _createForOfIteratorHelper(slips || []),
                  _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var slip = _step9.value;
                    var key = slip === null || slip === void 0 ? void 0 : slip.publicKey;
                    if (key && !out.includes(key)) {
                      out.push(key);
                    }
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
                return out;
              };
              sorted = txs.slice().sort(function (a, b) {
                return Number(b.timestamp || 0) - Number(a.timestamp || 0);
              });
              return _context7.a(2, {
                count: txs.length,
                limit: limit,
                transactions: sorted.slice(0, limit).map(function (tx) {
                  var type_num = Number(tx.type);
                  var size = 0;
                  if (tx.buffer) {
                    size = Buffer.from(tx.buffer, 'base64').length;
                  }
                  return {
                    signature: text(tx.signature),
                    timestamp: text(tx.timestamp),
                    type: types[type_num] || String(type_num),
                    fees: text(tx.total_fees),
                    size: size,
                    replacements: Number(tx.txs_replacements || 0),
                    hops: Array.isArray(tx.routing_path) ? tx.routing_path.length : 0,
                    from: keys(tx.from),
                    to: keys(tx.to)
                  };
                })
              });
          }
        }, _callee7);
      }));
      function snapshotMempool() {
        return _snapshotMempool.apply(this, arguments);
      }
      return snapshotMempool;
    }()
  }, {
    key: "snapshotBlockchain",
    value: function () {
      var _snapshotBlockchain = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this$app$core, _Object$getPrototypeO, _this$app$options;
        var bc, text, zero_hash, get_blockchain_state, live, consensus, wasm_blocks, recent, _t19, _t20, _t21, _t22, _t23, _t24, _t25, _t26, _t27, _t28, _t29, _t30, _t31, _t32, _t33, _t34, _t35, _t36, _t37, _t38, _t39, _t40, _t41, _t42, _t43, _t44, _t45, _t46, _t47, _t48, _t49, _t50, _t51, _t52, _t53;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              bc = (_this$app$core = this.app.core) === null || _this$app$core === void 0 ? void 0 : _this$app$core.blockchain;
              if (bc) {
                _context8.n = 1;
                break;
              }
              throw new Error('The Saito core blockchain is not available.');
            case 1:
              text = function text(value) {
                if (value === null || value === undefined || value === '') {
                  return '';
                }
                if (typeof value === 'bigint') {
                  return value.toString();
                }
                return String(value);
              };
              zero_hash = '0000000000000000000000000000000000000000000000000000000000000000'; // saito-js decorates this instance with a get() wrapper that calls the
              // same instance method again. Use the WASM prototype implementation to
              // avoid that recursive wrapper while retaining the live chain state.
              get_blockchain_state = (_Object$getPrototypeO = Object.getPrototypeOf(bc)) === null || _Object$getPrototypeO === void 0 ? void 0 : _Object$getPrototypeO.get;
              _t20 = typeof get_blockchain_state === 'function';
              if (!_t20) {
                _context8.n = 3;
                break;
              }
              _context8.n = 2;
              return get_blockchain_state.call(bc);
            case 2:
              _t20 = _context8.v;
            case 3:
              _t19 = _t20;
              if (_t19) {
                _context8.n = 4;
                break;
              }
              _t19 = {};
            case 4:
              live = _t19;
              consensus = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 ? void 0 : _this$app$options.consensus) || {};
              _context8.n = 5;
              return bc.getBlocks(10, false);
            case 5:
              _t21 = _context8.v;
              if (_t21) {
                _context8.n = 6;
                break;
              }
              _t21 = [];
            case 6:
              wasm_blocks = _t21;
              recent = wasm_blocks.map(function (block) {
                var _block$instance, _block$totalFees, _block$burnFee, _block$hasGoldenTicke;
                return {
                  id: text(block.id),
                  hash: text(block.hash),
                  previous_hash: text(block.previousBlockHash || block.previous_block_hash),
                  timestamp: text(block.timestamp),
                  creator: text(block.creator || ((_block$instance = block.instance) === null || _block$instance === void 0 ? void 0 : _block$instance.creator)),
                  fees: text((_block$totalFees = block.totalFees) !== null && _block$totalFees !== void 0 ? _block$totalFees : block.total_fees),
                  burnfee: text((_block$burnFee = block.burnFee) !== null && _block$burnFee !== void 0 ? _block$burnFee : block.burnfee),
                  difficulty: text(block.difficulty),
                  treasury: text(block.treasury),
                  graveyard: text(block.graveyard),
                  golden_ticket: !!((_block$hasGoldenTicke = block.hasGoldenTicket) !== null && _block$hasGoldenTicke !== void 0 ? _block$hasGoldenTicke : block.has_golden_ticket)
                };
              });
              _t22 = text;
              _context8.n = 7;
              return bc.get_latest_block_id();
            case 7:
              _t23 = _t22(_context8.v);
              _t24 = text;
              _context8.n = 8;
              return bc.get_last_block_id();
            case 8:
              _t25 = _t24(_context8.v);
              _t26 = text;
              _context8.n = 9;
              return bc.get_last_block_hash();
            case 9:
              _t27 = _t26(_context8.v);
              _t28 = text;
              _context8.n = 10;
              return bc.get_last_timestamp();
            case 10:
              _t29 = _t28(_context8.v);
              _t30 = text;
              _context8.n = 11;
              return bc.get_last_burnfee();
            case 11:
              _t31 = _t30(_context8.v);
              _t32 = text;
              _context8.n = 12;
              return bc.get_genesis_block_id();
            case 12:
              _t33 = _t32(_context8.v);
              _t34 = text;
              _context8.n = 13;
              return bc.get_genesis_timestamp();
            case 13:
              _t35 = _t34(_context8.v);
              _t36 = text(live.genesis_period || consensus.genesis_period);
              _t37 = text;
              _context8.n = 14;
              return bc.get_fork_id();
            case 14:
              _t38 = _t37(_context8.v);
              _t39 = text;
              _context8.n = 15;
              return bc.get_lowest_acceptable_block_id();
            case 15:
              _t40 = _t39(_context8.v);
              _t41 = text;
              _context8.n = 16;
              return bc.get_lowest_acceptable_block_hash();
            case 16:
              _t42 = _t41(_context8.v);
              _t43 = text;
              _context8.n = 17;
              return bc.get_prune_after_blocks();
            case 17:
              _t44 = _t43(_context8.v);
              _t45 = text;
              _context8.n = 18;
              return bc.get_block_confirmation_limit();
            case 18:
              _t46 = _t45(_context8.v);
              _t47 = text(live.social_stake_period || consensus.default_social_stake_period);
              _t48 = !!live.is_loading;
              _t49 = !!live.is_loaded;
              _t50 = text(consensus.heartbeat_interval);
              _t51 = !!consensus.disable_block_production;
              _t52 = zero_hash;
              _t53 = recent;
              return _context8.a(2, {
                latest_block_id: _t23,
                last_block_id: _t25,
                last_block_hash: _t27,
                last_timestamp: _t29,
                last_burnfee: _t31,
                genesis_block_id: _t33,
                genesis_timestamp: _t35,
                genesis_period: _t36,
                fork_id: _t38,
                lowest_acceptable_block_id: _t40,
                lowest_acceptable_block_hash: _t42,
                prune_after_blocks: _t44,
                block_confirmation_limit: _t46,
                social_stake_period: _t47,
                is_loading: _t48,
                is_loaded: _t49,
                heartbeat_interval: _t50,
                disable_block_production: _t51,
                zero_hash: _t52,
                recent: _t53
              });
          }
        }, _callee8, this);
      }));
      function snapshotBlockchain() {
        return _snapshotBlockchain.apply(this, arguments);
      }
      return snapshotBlockchain;
    }()
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      for (var a in options) {
        var current = this.app.options[a];
        var incoming = options[a];
        var both_objects = current && _typeof(current) === 'object' && !Array.isArray(current) && incoming && _typeof(incoming) === 'object' && !Array.isArray(incoming);
        if (both_objects) {
          for (var b in incoming) {
            this.app.options[a][b] = incoming[b];
          }
        } else {
          this.app.options[a] = incoming;
        }
      }
      this.app.storage.saveOptions();
      return this.writeOptions(options);
    }
  }, {
    key: "writeOptions",
    value: function writeOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = this.app.storage.returnPath();
      var fs = this.app.storage.returnFileSystem();
      if (!fs || !path) {
        return 'Filesystem is not available on this server.';
      }
      var filename = path.normalize("".concat(__dirname, "/../../config/options"));
      try {
        if (!fs.existsSync(filename)) {
          return "Admin cannot find ".concat(filename, ".");
        }
        var optFile = fs.readFileSync(filename, {
          encoding: 'UTF-8'
        });
        optFile = optFile.replace(/\s/g, '').replace(/'/g, "\"");
        optFile = JSON.parse(optFile);
        for (var a in options) {
          if (optFile[a] && _typeof(optFile[a]) === 'object' && !Array.isArray(optFile[a]) && _typeof(options[a]) === 'object' && !Array.isArray(options[a])) {
            Object.assign(optFile[a], options[a]);
          } else {
            optFile[a] = options[a];
          }
        }
        fs.writeFileSync(filename, JSON.stringify(optFile, null, 2));
      } catch (err) {
        return this.returnWriteError(filename, err);
      }
      return null;
    }
  }, {
    key: "returnWriteError",
    value: function returnWriteError(filename, err) {
      if ((err === null || err === void 0 ? void 0 : err.code) === 'EACCES' || (err === null || err === void 0 ? void 0 : err.code) === 'EPERM') {
        return "We couldn't update ".concat(filename, " because this file is not writable by the Saito server. The user account that runs Saito needs write permission for that file. Give that account write access, then try again.");
      }
      return (err === null || err === void 0 ? void 0 : err.message) || String(err);
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var _this4 = this;
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var webdir = "".concat(__dirname, "/web");
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var admin_self = this;
      var serverFn = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(req, res) {
          var html;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                _context9.n = 1;
                return AdminHome(app, admin_self, app.build_number, _this4.publicKey);
              case 1:
                html = _context9.v;
                if (res.finished) {
                  _context9.n = 2;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context9.a(2, res.send(html));
              case 2:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function serverFn(_x8, _x9) {
          return _ref.apply(this, arguments);
        };
      }();
      expressapp.get(uri, serverFn);
      expressapp.get("".concat(uri, "/module-image/:module"), function (req, res) {
        var fs = app.storage.returnFileSystem();
        var path = app.storage.returnPath();
        return serveModuleImage(fs, path, path.resolve(__dirname, '..'), req, res);
      });
      expressapp.use(uri, express["static"](webdir));
    }
  }, {
    key: "returnDefaultModules",
    value: function returnDefaultModules() {
      return ['admin', 'arcade', 'archive', 'blog', 'chat', 'chess', 'crypto', 'devtools', 'encrypt', 'disburse'];
    }
  }]);
}(ModTemplate);
module.exports = Admin;